import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IFeedbackItem } from "src/Types/module/feedback/feedback.types";
import FeedbackTableRow from "./FeedbackTableRow";
import ViewFeedbackModal from "./ViewFeedbackModal";

const FeedbackList = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [selectedRating, setSelectedRating] = useState<string>("");
	const [selectedUserType, setSelectedUserType] = useState<string>("");
	const [searchTerm, setSearchTerm] = useState<string>("");

	const [selectedFeedback, setSelectedFeedback] =
		useState<IFeedbackItem | null>(null);
	const [openModal, setOpenModal] = useState<boolean>(false);

	const queryParams: Record<string, any> = {
		...pagination,
	};
	if (selectedRating && selectedRating !== "all") {
		queryParams.rating = selectedRating;
	}
	if (selectedUserType && selectedUserType !== "all") {
		queryParams.user_type = selectedUserType;
	}
	if (searchTerm) {
		queryParams.search = searchTerm;
	}

	const { data, isLoading } = useGetQueryWithTotal<IFeedbackItem[]>({
		endPoint: "/api/feedback",
		queryKeys: [
			"Feedbacks",
			selectedRating,
			selectedUserType,
			searchTerm,
			pagination.skip,
			pagination.limit,
		],
		params: queryParams,
	});

	const feedbackList: IFeedbackItem[] = Array.isArray(data?.data)
		? data.data
		: Array.isArray(data)
			? data
			: [];

	const totalCount = data?.total ?? feedbackList.length ?? 0;

	const handleOpenViewModal = (feedback: IFeedbackItem) => {
		setSelectedFeedback(feedback);
		setOpenModal(true);
	};

	const handleCloseViewModal = () => {
		setSelectedFeedback(null);
		setOpenModal(false);
	};

	return (
		<CommCard
			headerTitle={`Feedback List (${totalCount})`}
			helmetTitle="BTTF - Feedback & Suggestions"
			showCardHeader
			showStatus
			statusLabel="Filter by Rating"
			statusOptions={[
				{ id: "all", name: "All Ratings" },
				{ id: "5", name: "5 Stars (★★★★★)" },
				{ id: "4", name: "4 Stars (★★★★)" },
				{ id: "3", name: "3 Stars (★★★)" },
				{ id: "2", name: "2 Stars (★★)" },
				{ id: "1", name: "1 Star (★)" },
			]}
			handleSelectStatus={(rating) => setSelectedRating(rating)}
			showStatus1
			statusLabel1="Filter by User Type"
			statusOptions1={[
				{ id: "all", name: "All User Types" },
				{ id: "visitor", name: "Visitor" },
				{ id: "b2b", name: "B2B" },
			]}
			handleSelectStatus1={(userType) => setSelectedUserType(userType)}
			showSearch
			searchPlaceHolder="Search by name, email, or org..."
			handleSearchFun={(search) => setSearchTerm(search)}
		>
			<Box translate="no" className="notranslate">
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell><span>SL.</span></TableCell>
								<TableCell><span>User Type</span></TableCell>
								<TableCell><span>Name &amp; Organization</span></TableCell>
								<TableCell><span>Contact</span></TableCell>
								<TableCell><span>Rating</span></TableCell>
								<TableCell><span>Feedback</span></TableCell>
								<TableCell><span>Date</span></TableCell>

							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : feedbackList.length > 0 ? (
							<TableBody>
								{feedbackList.map((feedback, idx) => (
									<FeedbackTableRow
										key={feedback.id}
										feedback={feedback}
										sl={pagination.skip + idx + 1}
										onView={handleOpenViewModal}
									/>
								))}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<CommonPagination
					total={totalCount}
					paginationCalFun={(limit, skip) => setPagination({ limit, skip })}
					dataShowPerPage={50}
				/>
			</Box>

			{/* Full details modal */}
			<ViewFeedbackModal
				open={openModal}
				handleClose={handleCloseViewModal}
				feedback={selectedFeedback}
			/>
		</CommCard>
	);
};

export default FeedbackList;
